<header class="main-header">
  <div class="nav-hamburguer" (click)="showNav()">
    <img src="assets/icons/menu.svg" alt="Logo" />
  </div>
  <div class="nav-hamburguer-mobile" (click)="showNavMobile()">
    <img src="assets/icons/menu.svg" alt="Logo" />
  </div>
  <div class="left-section" [ngClass]="{displaynone:viewBar}">
    <!-- <i nz-icon nzType="menu" class="menu-icon"></i> -->
    <a class="logo" [routerLink]="['']">
      <img src="assets/icons/main-icon.svg" alt="Logo" />
    </a>


    <button nz-button nzType="default" class="subscribe-btn"><a href="https://back.losandespass.com.ar/frames/forms/LAP/Suscripcion">Suscribite</a></button>
  </div>
  <div class="nav-others-links" [ngClass]="{linksOthers:viewNav}">
    <ul>
        <li><a href="https://losandes2.mitiendanube.com/los-andes-pass/">
          Shows y eventos 
          <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
            </a>
          </li>
          <li>
            <a href="https://losandes2.mitiendanube.com/">
              Tienda los Andes
              <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
              </a>
          </li>
          <li>
             <a href="https://new.losandes.com.ar/descargatufactura/">
                Descargar Factura
                <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
              </a>
          </li>
            <li>
              <a href="https://back.losandespass.com.ar/frames/forms/LAP/CargaDeIncidencias">Autogestión
                <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
              </a>
            </li>
       </ul>
  </div>
  <!-- <div class="search-bar">
    <input nz-input placeholder="Buscá tu próximo beneficio" />
    <button nz-button nzShape="circle" nzType="primary">
      <i nz-icon nzType="search"></i>
    </button>
  </div> -->

  <nav class="nav-links">
    
    
    <div class="search-bar"  [ngClass]="{mobilebar: viewBar}">
      <input type="text" placeholder="Busca tu próximo beneficio" (input)="filterByName($event)" (focus)="changeLastRoute()"> 
      <button (click)="ViewMobileBar(true)"><img src="assets/icons/seach-icon.svg"  style="cursor: pointer;"></button>
    </div>
    <div class="nav-main-links" [ngClass]={linksMobile:viewNavMobile}>
      @if (viewNavMobile) {
      <button nz-button nzType="default" class="subscribe-btn-mobile"><a href="https://back.losandespass.com.ar/frames/forms/LAP/Suscripcion">Suscribite</a></button>
      }
      <a [routerLink]="['/beneficios']">
        Mapa
        <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" />
      </a>

      @if (viewNavMobile) {
        <a href=" https://losandes2.mitiendanube.com/los-andes-pass/">
        Shows y eventos 
        <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
      </a>
       <a href="https://losandes2.mitiendanube.com/">
        Tienda los Andes
        <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
      </a>
       <a href="https://new.losandes.com.ar/descargatufactura/">
        Descargar Factura
        <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
      </a>
      <a href="https://back.losandespass.com.ar/frames/forms/LAP/CargaDeIncidencias">Autogestión
            <!-- <img src="assets/icons/map-icon.svg" alt="Mapa" class="icon-right" /> -->
      </a>
      }
      
      <div class="categories"  #menuContainer>
      <a (click)="viewCategories()">
        Categorías
         <img src="assets/icons/dropdown-arrow.svg" alt="Logo" />
      </a>
        <ul [ngStyle]="isClickCategorie ? {display:''} : {display: 'none'}">
          <li *ngFor="let categorie of allCategories"  [value]="categorie.id"><a (click)="filterByCategorie(categorie.id)">{{categorie.nombre}}</a></li>
        </ul> 
      </div>
    </div>
      <div class="cancel-button"  [ngClass]="{displaynone:!viewBar}">
        <button (click)="ViewMobileBar(false)">Cancelar</button>
      </div>


    <div class="nav-action-links "  [ngClass]="{displaynone:viewBar}">
      <a (click)="navigateToProfile()" style="cursor: pointer;">
       <span class="text"> {{ sessionText }} </span>
        <span class="icon-circle">
          <img src="assets/icons/session-icon.svg" [alt]="sessionText" />
        </span>
      </a>
      <a href="https://www.instagram.com/losandes_pass/">
        <img src="assets/icons/instagram-icon.svg" alt="Instagram" />
      </a>

      <!-- <a>
        <img src="assets/icons/wsp-icon.svg" alt="WhatsApp" />
      </a> -->
    </div>
  </nav>

</header>